<template>
  <main class="reseller-page activate-page" role="main">
    <vue-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false"></vue-loading>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-5 activate-section">
        <div class="wizard-container" v-if="!isLoading">
          <vue-good-wizard
            ref="wizard"
            :onNext="nextClick"
            :onBack="backClick"
            :steps="resellerSteps"
          >
            <div slot="sim-validation">
              <sim-validation @valid-sim="updateSimNumber"></sim-validation>
            </div>
            <div slot="customer-details">
              <customer-details
                @cancel="cancel"
                @valid-subscriber="nextStep"
                @clear-subscriber="resetSubscriber"
                :subscriber.sync="subscriber"
              ></customer-details>
            </div>
            <div slot="rica-details">
              <rica-details
                @back="back"
                @update-address="updateAddress"
                @activated="completeActivation"
                :subscriber.sync="subscriber"
                :sim_number.sync="sim_number"
                :employee_code="employee_code"
              ></rica-details>
            </div>
            <div slot="complete">
              <complete @cancel="cancel" :activation="activation"></complete>
            </div>
          </vue-good-wizard>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 image-section">
        <img
          class="img-fluid"
          src="/assets/images/backgrounds/me-you-activation-image.jpg"
          alt="Acivation-Input-Image"
        />
      </div>
    </div>
  </main>
</template>

<script>
import { GoodWizard } from "vue-good-wizard";
import SimValidation from "./sim-validation.vue";
import CustomerDetails from "./customer-details.vue";
import RicaDetails from "./rica-details.vue";
import Complete from "./complete.vue";

import store from "@/store";

import SubscriberModel from "@/models/subscriber.model.js";

export default {
  name: "reseller",
  components: {
    "vue-good-wizard": GoodWizard,
    "sim-validation": SimValidation,
    "customer-details": CustomerDetails,
    "rica-details": RicaDetails,
    complete: Complete
  },
  data() {
    return {
      is_loading: true,
      resellerSteps: [
        {
          slot: "sim-validation"
        },
        {
          slot: "customer-details"
        },
        {
          slot: "rica-details"
        },
        {
          slot: "complete"
        }
      ],
      sim_number: "",
      employee_code: "",
      subscriber: new SubscriberModel(),
      activation: null,
      current_page: 0
    };
  },
  computed: {
    isLoading() {
      return store.state.products.is_loading;
    }
  },
  beforeMount() {
    var self = this;
    self.registerListeners();
  },
  mounted() {},
  methods: {
    nextClick(currentPage) {
      var self = this;
      self.current_page = currentPage;
    },
    backClick(currentPage) {
      var self = this;
      self.current_page = currentPage;
    },
    registerListeners() {},
    updateSimNumber(resellerDetails) {
      var self = this;
      self.$log.debug("Reseller", resellerDetails);
      self.sim_number = resellerDetails.sim_number;
      self.employee_code = resellerDetails.employee_code;
      self.nextStep(true);
    },
    completeActivation(activation) {
      var self = this;
      self.activation = activation;
      self.nextStep(true);
    },
    updateAddress(add) {
      var self = this;
      self.address = add;
    },
    resetSubscriber() {
      var self = this;
      self.subscriber = new SubscriberModel();
    },
    nextStep(goNext) {
      var self = this;
      self.$refs.wizard.goNext(goNext);
    },
    cancel(is_cancel) {
      var self = this;
      self.$log.debug("wizard cancel");
      if (is_cancel) self.$refs.wizard.goTo(0);
    },
    back() {
      var self = this;
      if (self.current_page > 0) self.$refs.wizard.goTo(self.current_page - 1);
    }
  }
};
</script>